<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-container">
				<div class="w-128 m-4">
					<p class="text-center animate-pulse">
						<app-icon icon="bell" class="text-primary text-3xl mr-2" />
						<span class="text-3xl font-semibold text-primary">Warning!</span>
					</p>
					<p class="text-13 mb-4">{{ alert.description }}</p>
					<app-table v-if="alert.budgets" :columns="columns" :data="alert.budgets" :searchable="false">
						<template v-slot:amount="{ item }">
							{{ $filters.formatCurrency(item.amount, item.currency) }}
						</template>
						<template v-slot:date="{ item }">
							{{ $filters.formatShortDate(item.date) }}
						</template>
						<template v-slot:status="{ item }">
							<span class="text-white text-10 px-1 py-px rounded-md ml-1 bg-primary">
								{{ item.status }}
							</span>
						</template>
						<template v-slot:invoice="{ item }">
							<div class="cursor-pointer" @click="exportInvoice(item.invoice)">
								<app-icon icon="download" />
								Download
							</div>
						</template>
					</app-table>
					<div class="flex justify-end mt-2">
						<app-button class="btn btn-primary transparent small ml-2" @click="closeModal"
							>Make the payment now</app-button
						>
					</div>
				</div>
			</div>
			<app-section class="absolute right-0 bottom-0 m-4 bg-white">
				<div class="flex items-center gap-1">
					<span>Do you need support?</span>
				</div>
				<div class="flex items-center gap-1">
					<div class="bg-gray-300 rounded-full px-4">
						<app-icon class="text-gray-600 mr-2" icon="phone" />
						<a href="tel:+35544505500" class="text-gray-600">+355 44 50 5500</a>
					</div>
					<whats-app-button phone="+35544505500" />
				</div>
			</app-section>
		</div>
	</transition>
</template>

<script>
	import AppTable from '@/components/app/AppTable.vue';
	import ExportService from '@/services/ExportService';
	import UtilityService from '@/services/UtilityService';
	import AppIcon from '@/components/app/AppIcon.vue';
	import WhatsAppButton from '@/components/app/WhatsAppButton.vue';
	import AppSection from '@/components/app/AppSection.vue';
	import store from '@/store';
	import RouteNames from '@/router/names';

	export default {
		name: 'FinanceAlertModal',
		components: { AppSection, WhatsAppButton, AppIcon, AppTable },
		data: () => ({
			columns: [
				{ key: 'number', label: 'Number' },
				{ key: 'date', label: 'Date' },
				{ key: 'amount', label: 'Amount' },
				{ key: 'status', label: 'Status' },
				{ key: 'invoice', label: 'Invoice' },
			],
		}),
		props: {
			alert: {
				required: true,
			},
		},
		methods: {
			closeModal() {
				this.$router.push({
					name: RouteNames.CompanyBudgets,
				});
				this.$emit('close');
				store.dispatch('setFinanceAlert', {});
			},
			exportInvoice(invoice) {
				const invoiceToExport = {
					Id: invoice.id,
					Date: UtilityService.filters.formatShortDate(invoice['docDate']),
					Status: invoice && invoice['unPaidAmountCents'] <= invoice['paidAmountCents'] ? 'Paid' : 'Unpaid',
					Restaurant: invoice.restaurant['restaurantName'],
					'%':
						invoice.restaurant['baboonPercentage'] +
						invoice.restaurant['courierPercentage'] +
						invoice.restaurant['marketingPercentage'],
					'Vat%': invoice.restaurant['vat'],
					'Off.#': invoice['officialNo'],
					'Off.Date': UtilityService.filters.formatShortDate(invoice['officialDate']),
					Sales: `${invoice['accManager'].name} ${invoice['accManager'].name}`,
					Subtotal: invoice['amountNoVatCents'] / 100,
					Vat: invoice['vatCents'] / 100,
					Total: (invoice['vatCents'] + invoice['amountNoVatCents']) / 100,
					Paid: invoice['paidAmountCents'] / 100,
					Unpaid: (invoice['vatCents'] + invoice['amountNoVatCents'] - invoice['paidAmountCents']) / 100,
				};
				ExportService.export([invoiceToExport], 'Invoice', 'true').catch((e) =>
					this.$notificationService.error(e)
				);
			},
		},
	};
</script>

<style scoped></style>
